// Iconografía propia Ona — mismas rutas SVG que el prototipo (docs/05).
// Rejilla 24×24 · trazo 1.9 redondeado · firma aqua: accent (trazo) / dot (relleno).
import React from 'react';
import Svg, { Circle, Path, Rect, Text as SvgText } from 'react-native-svg';
import { C } from '@/constants/theme';

export type IconName =
  | 'pulse' | 'hoteles' | 'ia' | 'alertas'
  | 'helm' | 'bellhop' | 'trend' | 'coin' | 'nodes' | 'people' | 'key'
  | 'bed' | 'chartdown' | 'sync' | 'banknote' | 'doc' | 'check'
  | 'wrench' | 'case' | 'cal' | 'card' | 'mail' | 'warn' | 'clock' | 'play' | 'alarm' | 'link' | 'pin'
  | 'micro' | 'parar';

interface Props {
  name: IconName;
  size?: number;
  color?: string;
  accent?: string;
}

export default function OnaIcon({ name, size = 20, color = C.ink, accent = C.aqua }: Props) {
  const p = { stroke: color, strokeWidth: 1.9, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, fill: 'none' as const };
  const w = { ...p, stroke: accent };
  const dot = { fill: accent };

  const body = (() => {
    switch (name) {
      case 'pulse':
        return (<><Path {...p} d="M2.5 13h3.1l2-5.2 3.4 9 2.3-5.8" /><Path {...w} d="M13.6 13q2.3-2.7 4.6 0t4.6 0" /></>);
      case 'hoteles':
        return (<>
          <Path {...p} d="M5.5 19V7a2.5 2.5 0 0 1 2.5-2.5h8A2.5 2.5 0 0 1 18.5 7v12" />
          <Path {...p} d="M10 19v-2.4a2 2 0 0 1 4 0V19" />
          <Path {...p} d="M9.6 8.4h.01M14.4 8.4h.01M9.6 11.9h.01M14.4 11.9h.01" />
          <Path {...w} d="M2.6 20.7q2.35-1.9 4.7 0t4.7 0t4.7 0t4.7 0" />
        </>);
      case 'ia':
        return (<>
          <Path {...p} d="M4 7a2.5 2.5 0 0 1 2.5-2.5h11A2.5 2.5 0 0 1 20 7v6.2a2.5 2.5 0 0 1-2.5 2.5h-7L6.7 19v-3.3A2.5 2.5 0 0 1 4 13.2z" />
          <Path {...w} d="M8.2 10.3q1.9-2 3.8 0t3.8 0" />
        </>);
      case 'alertas':
        return (<>
          <Path {...p} d="M12 4.1a5.6 5.6 0 0 1 5.6 5.6c0 3.9 1.5 5.4 1.5 5.4H4.9s1.5-1.5 1.5-5.4A5.6 5.6 0 0 1 12 4.1z" />
          <Path {...w} d="M10.1 18.4a2 2 0 0 0 3.8 0" />
        </>);
      case 'helm':
        return (<>
          <Circle {...p} cx={12} cy={12} r={5.4} />
          <Circle {...dot} cx={12} cy={12} r={1.7} />
          <Path {...p} d="M12 6.6V3.4M12 20.6v-3.2M6.6 12H3.4M20.6 12h-3.2M8.2 8.2 6 6M15.8 8.2 18 6M8.2 15.8 6 18M15.8 15.8 18 18" />
        </>);
      case 'bellhop':
        return (<>
          <Path {...p} d="M5.3 15.4a6.7 6.7 0 0 1 13.4 0" />
          <Path {...p} d="M3.8 18.2h16.4" />
          <Path {...p} d="M12 8.7V7.2" />
          <Circle {...dot} cx={12} cy={5.6} r={1.3} />
        </>);
      /* 🔴 MICRÓFONO PROPIO, no un emoji. Patricio: «el icono tiene que ser acorde
         a la app que estamos haciendo». Estaba puesto el emoji 🎙, que cada
         sistema dibuja a su manera y encima en color — al lado de veintiocho
         iconos de trazo 1.9 se veía como lo que era: un parche.
         Lleva la firma de la casa: la cápsula y el pie en trazo, y la ONDA aqua
         saliendo del micro — el mismo gesto de las olas que usan `pulse`, `ia` y
         `hoteles`. Así el botón de hablarle a Noa pertenece al mismo alfabeto. */
      case 'micro':
        return (<>
          <Path {...p} d="M12 4.2a2.6 2.6 0 0 1 2.6 2.6v4.4a2.6 2.6 0 0 1-5.2 0V6.8A2.6 2.6 0 0 1 12 4.2z" />
          <Path {...p} d="M7.4 11a4.6 4.6 0 0 0 9.2 0" />
          <Path {...p} d="M12 15.6v3.1M9.4 18.7h5.2" />
          <Path {...w} d="M18.6 7.3q1.9 2.1 0 4.2" />
        </>);
      /* El cuadrado de parar, redondeado como el resto del sistema. */
      case 'parar':
        return (<Rect {...p} x={7.2} y={7.2} width={9.6} height={9.6} rx={2.4} fill={color} />);
      case 'trend':
        return (<><Path {...p} d="M3.5 16.8q2.6-3 5.1-1t4.9-3.1l4.6-5.1" /><Path {...w} d="M14.3 7.6h4.8v4.8" /></>);
      case 'coin':
        return (<>
          <Circle {...p} cx={12} cy={10.6} r={6.4} />
          <SvgText x={12} y={13.9} textAnchor="middle" fontSize={8.6} fontWeight="800" fontFamily="Sora_800ExtraBold" fill={color}>€</SvgText>
          <Path {...w} d="M5.6 20.6q2.15-1.7 4.3 0t4.2 0t4.3 0" />
        </>);
      case 'nodes':
        return (<>
          <Circle {...dot} cx={4.4} cy={12} r={1.5} />
          <Circle {...dot} cx={19.6} cy={12} r={1.5} />
          <Path {...p} d="M6.2 12h1.9l1.8-4.2 3 8.4 1.8-4.2h3.1" />
        </>);
      case 'people':
        return (<>
          <Circle {...p} cx={9} cy={8.3} r={2.6} />
          <Path {...p} d="M4.3 18.7a4.9 4.9 0 0 1 9.4 0" />
          <Circle {...w} cx={16.9} cy={9.4} r={2.1} />
          <Path {...w} d="M14.7 18.7a4.3 4.3 0 0 1 5.5-3.3" />
        </>);
      case 'key':
        return (<>
          <Circle {...p} cx={7.7} cy={8.1} r={3.5} />
          <Circle {...dot} cx={7.7} cy={8.1} r={1.1} />
          <Path {...p} d="M10.3 10.7l8.2 8.2M15 15.4l-1.9 1.9M17.9 12.5 16 14.4" />
        </>);
      case 'bed':
        return (<>
          <Path {...p} d="M3.5 18.6V7.4" />
          <Path {...p} d="M3.5 15.4h17v3.2" />
          <Circle {...p} cx={7} cy={11.2} r={1.6} />
          <Path {...p} d="M10.2 12.8h6.8a3.5 3.5 0 0 1 3.5 2.6" />
        </>);
      case 'chartdown':
        return (<><Path {...p} d="M4 6.4l4.9 4.9 2.8-2.8 7 7" /><Path {...w} d="M19.4 11.1v4.6h-4.6" /></>);
      case 'sync':
        return (<>
          <Path {...p} d="M18.6 7.1A7.3 7.3 0 0 0 5.7 9.7" />
          <Path {...p} d="M5.4 5.3v4.4h4.4" />
          <Path {...p} d="M5.4 16.9a7.3 7.3 0 0 0 12.9-2.6" />
          <Path {...w} d="M18.6 18.7v-4.4h-4.4" />
        </>);
      case 'banknote':
        return (<>
          <Rect {...p} x={3} y={6.8} width={18} height={10.6} rx={2.2} />
          <Circle {...p} cx={12} cy={12.1} r={2.4} />
          <Path {...w} d="M6.3 9.9v4.4M17.7 9.9v4.4" />
        </>);
      case 'doc':
        return (<>
          <Path {...p} d="M7 3.8h6.4l5.1 5.1v9.3a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5.8a2 2 0 0 1 2-2z" />
          <Path {...p} d="M13.4 3.8v5.1h5.1" />
          <Path {...w} d="M8.7 13.5h6.5M8.7 16.3h4.2" />
        </>);
      case 'check':
        return (<><Circle {...p} cx={12} cy={12} r={7.6} /><Path {...w} d="M8.6 12.4l2.4 2.4 4.5-5" /></>);
      case 'wrench':
        return (<Path {...p} d="M14.8 6.2a4.3 4.3 0 0 0-5.5 5.4l-5 5a2 2 0 1 0 2.9 2.9l5-5a4.3 4.3 0 0 0 5.4-5.5l-2.9 2.9-2.8-2.8z" />);
      case 'case':
        return (<>
          <Rect {...p} x={4} y={8} width={16} height={11} rx={2.2} />
          <Path {...p} d="M9.3 8V6.5a1.6 1.6 0 0 1 1.6-1.6h2.2a1.6 1.6 0 0 1 1.6 1.6V8" />
          <Path {...w} d="M4 12.1h16" />
        </>);
      case 'cal':
        return (<>
          <Rect {...p} x={4} y={5.6} width={16} height={13.8} rx={2.2} />
          <Path {...p} d="M8.3 3.9v3M15.7 3.9v3M4 9.9h16" />
          <Circle {...dot} cx={12} cy={14.4} r={1.3} />
        </>);
      case 'card':
        return (<>
          <Rect {...p} x={3.2} y={6} width={17.6} height={12} rx={2.2} />
          <Path {...p} d="M3.2 10h17.6" />
          <Path {...w} d="M6.5 14.6h4.2" />
        </>);
      case 'mail':
        return (<>
          <Rect {...p} x={3.2} y={5.8} width={17.6} height={12.4} rx={2.2} />
          <Path {...w} d="M4.6 8.3l7.4 5.1 7.4-5.1" />
        </>);
      case 'warn':
        return (<><Path {...p} d="M12 4.6 21 19.4H3z" /><Path {...w} d="M12 10.2v3.6M12 16.6v.2" /></>);
      case 'clock':
        return (<><Circle {...p} cx={12} cy={12} r={7.6} /><Path {...w} d="M12 7.9V12l3 1.8" /></>);
      case 'play':
        return (<Path {...p} d="M8.6 5.9v12.2L18.5 12z" />);
      case 'alarm':
        return (<>
          <Circle {...p} cx={12} cy={13.2} r={6.6} />
          <Path {...w} d="M12 9.9v3.3l2.3 1.4" />
          <Path {...p} d="M5.1 5.4 7.2 3.7M18.9 5.4 16.8 3.7" />
        </>);
      case 'link':
        return (<>
          <Path {...p} d="M10.2 13.8l3.6-3.6" />
          <Path {...p} d="M8.9 11.1l-2.5 2.5a3.4 3.4 0 0 0 4.8 4.8l2.5-2.5" />
          <Path {...w} d="M15.1 12.9l2.5-2.5a3.4 3.4 0 0 0-4.8-4.8l-2.5 2.5" />
        </>);
      case 'pin':
        return (<>
          <Path {...p} d="M12 20.5s-6.3-5.5-6.3-9.9a6.3 6.3 0 0 1 12.6 0c0 4.4-6.3 9.9-6.3 9.9z" />
          <Circle {...w} cx={12} cy={10.4} r={2} />
        </>);
      default:
        return null;
    }
  })();

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      {body}
    </Svg>
  );
}
